module.exports = __webpack_public_path__ + "img/my-mood.png";